import React from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { inviteMemberEmailConverter } from "../../../../../../scCommon/scCommonFunc";

interface PartyMailInfoProps {
  partyData?: {
    member: string;
    memberEmail: string;
    party: string;
    emailRegTime: string;
  };
  secondaryMailAcc?: string;
}

interface SPartyInfoText {
  isLabel?: boolean;
}

export default function PartyMailInfo({
  partyData,
  secondaryMailAcc,
}: PartyMailInfoProps) {
  return (
    <PartyInfoContainer>
      <PartyInfoRow>
        <PartyInfoText isLabel>대상 :</PartyInfoText>
        <PartyInfoText>{partyData?.member}</PartyInfoText>
      </PartyInfoRow>
      <PartyInfoRow>
        <PartyInfoText isLabel>파티 :</PartyInfoText>
        <PartyInfoText>{partyData?.party}</PartyInfoText>
      </PartyInfoRow>
      <PartyInfoRow>
        <PartyInfoText isLabel>
          {secondaryMailAcc ? "세컨더리" : "파티"} 이메일 :
        </PartyInfoText>
        <PartyInfoText>
          {secondaryMailAcc
            ? secondaryMailAcc
            : partyData?.memberEmail?.includes("testgrove.pw") ||
              partyData?.memberEmail?.includes("linkidmail.com")
            ? partyData?.memberEmail
            : inviteMemberEmailConverter(
                Number(partyData?.party?.split("_")[0]),
                Number(partyData?.member?.split("_")[0])
              )}
        </PartyInfoText>
      </PartyInfoRow>
      <PartyInfoRow>
        <PartyInfoText isLabel>등록 이메일 :</PartyInfoText>
        <PartyInfoText>
          {secondaryMailAcc ? "-" : partyData?.memberEmail}
        </PartyInfoText>
      </PartyInfoRow>
      <PartyInfoRow>
        <PartyInfoText isLabel>파티 가입 일시 :</PartyInfoText>
        <PartyInfoText>
          {dayjs(partyData?.emailRegTime).format("YYYY-MM-DD HH:mm:ss")}
        </PartyInfoText>
      </PartyInfoRow>
    </PartyInfoContainer>
  );
}

const PartyInfoContainer = styled.div``;

const PartyInfoRow = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 2px;
  }
`;

const PartyInfoText = styled.span<SPartyInfoText>`
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: left;
  color: ${({ theme, isLabel }) => (isLabel ? "#9a9fa8" : theme.color.gray600)};
  margin-right: ${({ isLabel }) => (isLabel ? 12 : 0)}px;
`;
